import gql from "graphql-tag";
import { MEMBER_FRAGMENT } from "./fragment";

export const CREATE_MEMBER = gql`
  mutation CreateMember($input: CreateMemberInput!) {
    createMember(input: $input) {
      ...MemberInfo
    }
  }
  ${MEMBER_FRAGMENT}
`;

export const CHECK_EMAIL = gql`
  mutation CheckEmail($email: String!, $id: ID) {
    checkEmail(email: $email, id: $id)
  }
`;

export const SHARES_PERCENTS = gql`
  mutation SharesPercents(
    $shares: [SharesPercentInput]!
    $document: InputDocument
  ) {
    sharesPercents(shares: $shares, document: $document)
  }
`;

export const DELETE_MEMBER = gql`
  mutation DeleteMember($id: ID!) {
    deleteMember(id: $id) {
      ...MemberInfo
    }
  }
  ${MEMBER_FRAGMENT}
`;

export const CREATE_GET_ID = gql`
  mutation CreateKycApplication($failedUrl: String!, $succesUrl: String!) {
    createKycApplication(failedUrl: $failedUrl, succesUrl: $succesUrl)
  }
`;
